import { Form, FormProps, RcFile, Upload } from '@pankod/refine-antd'
import { useNotification, useTranslate } from '@pankod/refine-core'
import { definitions } from 'interfaces'
import { getRandomString, normalizeFile, supabaseClient } from 'utility'

type IssuesFilesUploadFormProps = {
  formProps: FormProps<{}>
  refetch: () => void
  issue: definitions['issues']
}

export const IssuesFilesUploadForm: React.FC<IssuesFilesUploadFormProps> = ({
  formProps,
  refetch,
  issue
}) => {
  const t = useTranslate()
  const { open } = useNotification()

  return (
    <Form
      {...formProps}
      layout="vertical"
      initialValues={{
        isActive: true,
        ...formProps.initialValues
      }}
      id="issues_files-form"
    >
      <Form.Item
        name="files"
        valuePropName="fileList"
        normalize={normalizeFile}
        noStyle
      >
        <Upload.Dragger
          listType='picture-card'
          customRequest={async ({
            file,
            onError,
            onSuccess
          }) => {
            const rcFile = file as RcFile
            const extension = rcFile.name.includes('.') ? rcFile.name.slice(rcFile.name.lastIndexOf('.')) : ''
            const safeFilePath = `${getRandomString()}/${getRandomString()}${extension}`

            const { error } = await supabaseClient
              .storage
              .from('issues')
              .upload(safeFilePath, file, {
                contentType: rcFile.type,
                upsert: false
              })

            if (error) {
              return onError?.(error)
            }

            const { data: uploadedData, error: urlError } = await supabaseClient.storage
              .from('issues')
              .getPublicUrl(safeFilePath)

            if (urlError) {
              return onError?.(urlError)
            }

            const { error: insertError } =
              await supabaseClient
                .from('issues_files')
                .insert({
                  issue_id: issue.id,
                  file_name: safeFilePath,
                  created_at: new Date().toISOString(),
                  public_url: uploadedData?.publicURL,
                  storage_bucket: 'issues',
                  storage_object_path: safeFilePath
                })

            if (insertError) {
              return open?.({
                type: 'error',
                message: t('notifications.errorMsg')
              })
            }

            const { signedURL } = await supabaseClient.storage
              .from('issues')
              .createSignedUrl(safeFilePath, 60)

            refetch()

            onSuccess?.(
              { url: signedURL },
              new XMLHttpRequest()
            )
          }}
        >
          <p className="ant-upload">
            {t('actions.dragFile')}
          </p>
        </Upload.Dragger>
      </Form.Item>
    </Form>
  )
}
